import { youtubeUrlToEmbed } from '~/utils'

const IframeVideo = ({
  title,
  src,
  className = 'aspect-video w-full',
}: {
  title: string
  src: string
  className?: string
}) => {
  const embed = youtubeUrlToEmbed(src) ?? null
  return embed ? (
    <iframe
      title={title}
      src={embed}
      className={className}
    />
  ) : null
}

export default IframeVideo
